var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleMusic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3038_22621)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 -1 0 48)",
    fill: "url(#paint0_linear_3038_22621)",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.658 33.656v-15c0-.562.312-.906.937-1.031L32.533 15c.687-.125 1.062.188 1.125.938v11.437c0 .938-1.407 1.563-4.219 1.875-5.344.844-4.5 9.844 2.813 7.406 2.812-1.031 3.28-3.75 3.28-6.468V8.25s0-1.875-1.593-1.406l-15.938 3.281s-1.218.188-1.218 1.688v19.03c0 .938-1.407 1.563-4.219 1.876-5.344.843-4.5 9.843 2.813 7.406 2.812-1.031 3.28-3.75 3.28-6.469z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3038_22621",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE243C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5B73"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3038_22621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleMusic);
export default __webpack_public_path__ + "static/media/appleMusic.689071fa1586d0a32fa34e3cd0296019.svg";
export { ForwardRef as ReactComponent };